"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StatusEnum = require("./enums/StatusEnum");
Object.keys(_StatusEnum).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StatusEnum[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StatusEnum[key];
    }
  });
});
var _UIElementSizesEnum = require("./enums/UIElementSizesEnum");
Object.keys(_UIElementSizesEnum).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UIElementSizesEnum[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UIElementSizesEnum[key];
    }
  });
});
var _UIElementStatusEnum = require("./enums/UIElementStatusEnum");
Object.keys(_UIElementStatusEnum).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UIElementStatusEnum[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UIElementStatusEnum[key];
    }
  });
});
var _UIElementShapeEnum = require("./enums/UIElementShapeEnum");
Object.keys(_UIElementShapeEnum).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UIElementShapeEnum[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UIElementShapeEnum[key];
    }
  });
});